import { connect } from 'react-redux';
import ProductBrowser, { Props } from './ProductBrowser';
import { State } from '../../reducers/typings';

function mapStateToProps(state: State): Pick<Props, 'currentMenu' | 'loading'> {
  return {
    currentMenu: state.warehouse.currentMenu,
    loading: state.warehouse.isFetching,
  };
}

export default connect(mapStateToProps)(ProductBrowser);
